<template>
    <modal :name="name"
           adaptive
           height="98%"
           width="95%"
           :clickToClose="false"
           @before-open="beforeOpen"
           @before-close="beforeClose">
        <div class="container my-4">
            <div @click="closeModal" class="close-modal" v-tooltip="'Cancel action'">
                <i class="far fa-times fa-lg"></i>
            </div>

            <div class="row">
                <div class="col-md-6 offset-md-3">

                    <div class="card">
                        <div class="card-body text-center pt-5">

                            <img :src="isWebExpensesApp ? '/logo-webexpenses.png': '/header.logo.png'"
                                 :height="isWebExpensesApp ? 36 : 25"
                                 width="auto"
                                 :alt="`${appDisplayName} logo`">
                            <h5 class="mt-4">
                                Select a team
                                <span v-show="isLoading || isTwoFactorChecking" class="pl-2">
                                    <i class="fas fa-spinner fa-pulse fa-sm"></i>
                                </span>
                            </h5>

                            <ul class="teams-wrapper ml-auto mr-auto mt-5">
                                <li v-for="team in getTeams" :key="team.uuid"
                                    @click="onTeamSelect(team)"
                                    class="media team-card p-2">
                                    <avatar :username="team.name"
                                            :size="44"
                                            :src="teamsAvatars[team.uuid]">
                                    </avatar>

                                    <div class="media-body ml-3 text-left">
                                        <h5 class="mt-0 mb-1 text-bigger">{{ team.name }}</h5>
                                        <span class="text-muted">{{ team.incoming }}</span>
                                    </div>
                                </li>
                            </ul>

                            <a @click.prevent="cancelAction" href="#">cancel integration</a>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import {AUTH_FORCE_2FA_SETUP, AUTH_SET_ACTIVE_TEAM, SELECT_ACTIVE_TEAM_MODAL} from '@/store/mutations'
import {withConfirmation} from '@/decorators/withConfirmation'

export default {
    name: 'SelectActiveTeam',
    props: {
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            selectedTeam: null,
            isLoading: false,
            isTwoFactorChecking: false
        }
    },
    computed: {
        ...mapGetters([
            'activeTeam',
            'teamsAvatars',
            'getTeams',
            'selectActiveTeamModal'
        ])
    },
    methods: {
        ...mapMutations({
            setActiveTeam: AUTH_SET_ACTIVE_TEAM
        }),

        ...mapActions({
            force2faSetup: AUTH_FORCE_2FA_SETUP
        }),

        beforeOpen(params) {
            this.$bus.$on('2FA_SETUP_CANCEL', () => this.$modal.hide(this.name))
            this.$bus.$on('2FA_SETUP_COMPLETE', () => this.continueAction(this.selectedTeam))
        },

        beforeClose() {
            this.$bus.$off('2FA_SETUP_CANCEL')
            this.$bus.$off('2FA_SETUP_COMPLETE')
        },

        async onTeamSelect(team) {
            if (this.isLoading || this.isTwoFactorChecking) {
                return
            }

            this.selectedTeam = team
            if (team && team.force2fa) {
                this.isTwoFactorChecking = true
                const code = await this.force2faSetup()
                if ([500, 400].includes(code)) { // 400 - already enabled, 500 - 2fa get error
                    this.continueAction(team)
                }
                // else code 200 - 2fa setup modal will be shown
                this.isTwoFactorChecking = false
            } else {
                this.continueAction(team)
            }
        },

        async continueAction(team) {
            this.isLoading = true
            this.setActiveTeam(team)
            this.$modal.hide(this.name)
            this.isLoading = false
        },

        cancelAction() {
            this.$store.commit(SELECT_ACTIVE_TEAM_MODAL, {show: false, reason: null})
            this.$modal.hide(this.name)
        },

        closeModal() {
            withConfirmation({
                title: 'Cancel action',
                description: 'Are you sure you want to cancel?',
                onConfirm: this.cancelAction
            })
        }
    },
    watch: {
        selectActiveTeamModal(data) {
            if (data.show) {
                this.$modal.show(this.name)
            }
        }
    },
    mounted() {
        if (this.selectActiveTeamModal.show) {
            this.$modal.show(this.name)
        }
    }
}
</script>

<style scoped lang="scss">
.card-body {
    border: 1px solid #dadce0;
}

.team-card {
    /*max-width: 380px;*/
    padding: 3px;
    margin-bottom: 2px;

    &:hover {
        background: floralwhite;
        cursor: pointer;
    }
}

.teams-wrapper {
    max-height: calc(100vh - 200px);
    margin-top: 20px;
    margin-left: 0;
    padding-left: 0;
    overflow: scroll;
    max-width: 400px;
}

.close-modal {
    position: absolute;
    right: 50px;
    top: 25px;

    &:hover {
        cursor: pointer;
        transform: scale(1.2);
    }
}

.active-team {

}
</style>
